import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ExpenseAvailableItem, ExpenseDetail } from 'src/app/interfaces/expense';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OwnerDetail, OwnerType } from 'src/app/interfaces/owner';

import { DataMappingService } from 'src/app/services/data-mapping.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { PetService } from '../../services/pet.service'
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

@Component({
  selector: 'app-expense-detail',
  templateUrl: './expense-detail.component.html',
  styleUrls: ['./expense-detail.component.scss']
})
export class ExpenseDetailComponent implements OnInit {
  selectedExpense= {} as ExpenseDetail;
  public expenseDetailForm: FormGroup;
  isLoading = false;
  isNew = false;
  expenseDetailData = new FormData();
  isSavingExpense = false;
  public onClose= new Subject<boolean>();
  isExpenseAvailableItemsLoaded = false;
  expenseAvailableItems = [] as ExpenseAvailableItem[];
  selectedExpenseAvailableItem = {} as ExpenseAvailableItem;
  hasEditPermission: boolean = false;
  hasAddPermission: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private petService: PetService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private dataMappingService: DataMappingService,
    private jsonDataService: JsonDataService,
  ) {
    this.expenseDetailForm = this.formBuilder.group({
      item: ['', [Validators.required]],
      amount: ['', [Validators.required]],
      date: ['', [Validators.required]],
      note: '',
    });

    this.getExpenseAvailableItems();
  }

  ngOnInit(): void {
    console.log(`ExpenseDetailComponent, ngOnInit, This is expense detail modal`);
    console.log(`ExpenseDetailComponent, ngOnInit, isNew: ${this.isNew}`);
    if (!this.isNew) {
      console.log(`ExpenseDetailComponent, selectedExpense: ${JSON.stringify(this.selectedExpense)}`);
      this.patchExpenseDetailForm(this.selectedExpense);

      this.hasEditPermission = this.petService.hasPermission('api.change_expense');
      console.log(`ExpenseDetailComponent, hasEditPermission: ${this.hasEditPermission}`);
      // Disable form if user has no change expense permission
      this.disableForm();
    }
    else {
      this.hasAddPermission = this.petService.hasPermission('api.add_expense');
      console.log(`ExpenseDetailComponent, hasAddPermission: ${this.hasAddPermission}`);
    }
  }

  patchExpenseDetailForm(expense: ExpenseDetail) {
    this.expenseDetailForm.patchValue(expense);
  } // end of patchOwnerDetailForm

  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  saveExpense() {
    console.log(`saveExpense, isNew:${this.isNew}`);
    if (this.expenseDetailForm.invalid) {
      this.markFormGroupTouched(this.expenseDetailForm);
      return;
    }
    if(!this.isNew) {
      if (this.hasEditPermission){
        this.updateExpense();
      }
    } else {
      if (this.hasAddPermission) {
        this.createExpense();
      }
    }
  } // end of saveExpense

  updateExpense() {
    this.isSavingExpense = true;
    this.createExpenseCreateUpdatePayload();
    console.log(`updateExpense, ownerUpdateData:${this.expenseDetailData}`);
    this.petService.updateExpense(this.selectedExpense.id, this.expenseDetailData).subscribe({
      next: (response) => {
        this.isSavingExpense = false;
        console.log(`updateExpense, response: ${JSON.stringify(response)}`);
        this.hideModal();
      },
      error: (error) => {
        this.isSavingExpense = false;
        console.error(`updateExpense, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingExpense = false;
  } // end of updateExpense

  createExpense() {
    if (this.expenseDetailForm.invalid)
    {
      return;
    }

    this.isSavingExpense = true;
    this.createExpenseCreateUpdatePayload();
    console.log(`createExpense, owner data:${JSON.stringify(this.expenseDetailData)}`);
    this.petService.createExpense(this.expenseDetailData).subscribe({
      next: (response) => {
        this.isSavingExpense = false;
        console.log(`createExpense, response: ${JSON.stringify(response)}`);
        this.hideModal()
      },
      error: (error) => {
        this.isSavingExpense = false;
        console.error(`createExpense, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingExpense = false;
  } // end of createExpense

  createExpenseCreateUpdatePayload() {
    const formValues = this.expenseDetailForm.value;

    this.expenseDetailData.append('item', formValues.item);
    this.expenseDetailData.append('amount', formValues.amount);
    this.expenseDetailData.append('date', formValues.date);
    let note = formValues.note;
    console.log(`createExpenseCreateUpdatePayload, note: ${note}`);
    if (note != null && note.length>1)
      this.expenseDetailData.append('note', note);
  }  // end of createExpenseCreateUpdatePayload

  getExpenseAvailableItems() {
    this.isExpenseAvailableItemsLoaded = false;
    this.petService.getExpenseAvailableItems().subscribe({
      next: (response) => {
        console.log(`getExpenseAvailableItems, response: ${JSON.stringify(response)}`);
        this.expenseAvailableItems = response;
        this.isExpenseAvailableItemsLoaded = true;
      },
      error: (error) => {
        this.isExpenseAvailableItemsLoaded = true;
        console.error(`getExpenseAvailableItems, error: ${JSON.stringify(error)}`);
      }
    });
    this.isExpenseAvailableItemsLoaded = false;
  } // end of getExpenseAvailableItems

  onSelectExpenseAvailableItem (event: TypeaheadMatch): void{
    this.selectedExpenseAvailableItem = event.item;
    console.log(`onSelectExpenseAvailableItem, selectedExpenseAvailableItem:${JSON.stringify(this.selectedExpenseAvailableItem)}`);
  } // end of onSelectExpenseAvailableItem

  closeModal() {
    this.hideModal();
  } // end of closeModal

  hideModal() {
    this.onClose.next(true);
    this.bsModalRef.hide();
  } // end of hideModal

  disableForm(){
    if (!this.hasEditPermission) {
      this.expenseDetailForm.disable(); 
    }
  }
}
